import CollectionApi from 'client/api/v2/CollectionApi';

const oneCharErrorMessage = 'Search term must be longer than one character. SFDC restriction';

class KnowledgeApi extends CollectionApi {
  constructor() {
    super('/api/v2/knowledge/articles', {
      skip: 0,
      limit: 50,
      search: {
        searchTerm: '',
      },
    });
  }

  /**
   * @param  {String} searchValue
   * @param  {Number} limit
   */
  fetch(fields, customParams = {}) {
    this.defaultParams.fields = fields;

    const params = {
      ...this.defaultParams,
      ...customParams,
    };

    const {
      filter,
      limit,
      searchTerm,
      skip,
      sort,
    } = params;
    const cancelToken = null;

    if (!KnowledgeApi.isValidSearchTerm(searchTerm)) {
      throw new Error(oneCharErrorMessage);
    }
    return super.fetch(skip, limit, sort, searchTerm, cancelToken, filter);
  }

  // eslint-disable-next-line class-methods-use-this
  setSearchTerm(params, searchTerm) {
    if (searchTerm) {
      if (params && params.search) {
        // eslint-disable-next-line no-param-reassign
        params.search.searchTerm = searchTerm;
      }
    }
  }

  // API throws an error when the search term is a single character
  // This restriction is set by SFDC API
  static isValidSearchTerm(searchTerm) {
    if (!searchTerm) {
      return true;
    }
    return searchTerm.trim().length !== 1;
  }
}

export default new KnowledgeApi();
const { isValidSearchTerm } = KnowledgeApi;
export { isValidSearchTerm };
